import React, { useState, useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/cs';

dayjs.extend(weekday);
dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
dayjs.locale('cs');

const isWorkingDay = (date) => {
  const day = date.day();
  const month = date.month(); // 0 = leden, 4 = květen
  const dayOfMonth = date.date();

  const isWeekend = day === 0 || day === 6;
  const isHoliday =
    (dayOfMonth === 1 && month === 0) || // 1.1.
    (dayOfMonth === 1 && month === 4);   // 1.5.

  return !isWeekend && !isHoliday;
};

const getFirstWorkingDayNextMonth = () => {
  const nextMonth = dayjs().add(1, 'month').startOf('month');
  let date = nextMonth;
  while (!isWorkingDay(date)) {
    date = date.add(1, 'day');
  }
  return date;
};

const tabConfigs = {
  job: {
    label: 'Job Date',
    color: 'primary',
    background: '#e3f2fd',
    endpoint: 'https://fms.mauriceward.com/api/v1/mjt/update-date',
   // endpoint: 'https://autobots.z-technics.com/api/v1/mjt/update-date',
  //  endpoint: 'http://localhost:7600/update-date',
    // Local dev: http://localhost:7600/update-date
  },
  departure: {
    label: 'Departure Date',
    color: 'success',
    background: '#e8f5e9',
   endpoint: 'https://fms.mauriceward.com/api/v1/mjt/departure-date',
   // endpoint: 'https://autobots.z-technics.com/api/v1/mjt/departure-date',
  //  endpoint: 'http://localhost:7600/departure-date',

    // Local dev: http://localhost:7600/departure-date
  },
  eta: {
    label: 'ETA Date',
    color: 'warning',
    background: '#f5eddbff',
    endpoint: 'https://fms.mauriceward.com/api/v1/mjt/eta-date',
    //endpoint: 'https://autobots.z-technics.com/api/v1/mjt/eta-date',
    //  endpoint: 'http://localhost:7600/eta-date',

    // Local dev: http://localhost:7600/eta-date
  },
  etd: {
    label: 'ETD Date',
    color: 'secondary',
    background: '#ede7f6',
    endpoint: 'https://fms.mauriceward.com/api/v1/mjt/etd-date',
    //endpoint: 'https://autobots.z-technics.com/api/v1/mjt/etd-date',
    //endpoint: 'http://localhost:7600/etd-date',

    // Local dev: http://localhost:7600/etd-date
  }
};

const MoveJobPage = () => {
  const [selectedDate, setSelectedDate] = useState(getFirstWorkingDayNextMonth());
  const [inputText, setInputText] = useState('');
  const [results, setResults] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('job');
  const currentTab = tabConfigs[activeTab];

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setResults({});
  };

useEffect(() => {
  const token = localStorage.getItem('token');
  if (!token) {
    window.location.href = '/login';
  }
}, []);

  const handleSubmit = async () => {
    const token = 'EETWPGA-KCEMG3S-M8QEVBP-3KH2JDD';
    const username = localStorage.getItem('username');
    const endpoint = currentTab.endpoint;

    const cleaned = inputText
      .split('\n')
      .map(line => line.replace(/[^\w]/g, '').trim())
      .filter(line => line.length > 0);

    const newResults = {};
    setIsSubmitting(true);
   
    if (
      selectedDate.date() === 1 &&
      (selectedDate.month() === 0 || selectedDate.month() === 4)
    ) {
      alert('❌ Vybrané datum je státní svátek (1.1. nebo 1.5.), prosím zvol jiný pracovní den.');
      setIsSubmitting(false);
      return;
    }


    
for (const job_id of cleaned) {
  try {
    const res = await fetch(endpoint, {
   // const res = await fetch('https://autobots.z-technics.com/api/v1/mjt/update-date', {
   // const res = await fetch('http://localhost:7600/update-date', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-KEY': `${token}`
      },
      body: JSON.stringify({
        job_id,
        date: selectedDate.format('YYYY-MM-DD'),
        username
      })
    });

    const json = await res.json();

    if (res.ok && json.success) {
      newResults[job_id] = { status: 'success', message: null };
    } else {
      newResults[job_id] = {
        status: 'error',
        message: json.error || 'Unknown error'
      };
    }
  } catch (e) {
    newResults[job_id] = {
      status: 'error',
      message: 'Error with connection to API'
    };
  }
}

setResults(newResults);
setIsSubmitting(false);
  };


  return (
    <Box sx={{ p: 4, maxWidth: 900, mx: 'auto', backgroundColor: currentTab.background }}>
      <Typography variant="h4" gutterBottom>
        Date Manipulator - {currentTab.label}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        {Object.entries(tabConfigs).map(([key, { label, color }]) => (
          <Button
            key={key}
            variant={activeTab === key ? 'contained' : 'outlined'}
            color={color}
            onClick={() => handleTabChange(key)}
          >
            {label}
          </Button>
        ))}
      </Box>

      <TextField
        label="Datum"
        type="date"
        value={selectedDate.format('YYYY-MM-DD')}
        onChange={(e) => setSelectedDate(dayjs(e.target.value))}
        InputLabelProps={{ shrink: true }}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="Job IDs"
        multiline
        rows={6}
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        fullWidth
        placeholder="e.g. CZ25004284"
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          variant="contained"
          color={currentTab.color}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          Apply {currentTab.label}
        </Button>
      </Box>

      <Box sx={{ mt: 3 }}>
        {Object.entries(results).map(([job, { status, message }]) => (
          <Typography
            key={job}
            color={status === 'success' ? 'green' : 'error'}
            sx={{ whiteSpace: 'pre-line', mb: 1 }}
          >
            {job} {status === 'success' ? '✅' : `❌ ${message || ''}`}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default MoveJobPage;
